<script>
	import { cheatsheets } from '../stores/cheatsheets.js';
	export let params = {};
	$: cur_sheet = $cheatsheets.filter(sheet => sheet.id == params.id)[0];

</script>

Editing Cheatsheet {params.id}
<div class="editor-container">
	<a href="#/">
		<button on:click={cheatsheets.edit(cur_sheet)} class="safe" id="save-btn">Save</button>
	</a>
	<a href="#/">
		<button class="danger">Cancel</button>
	</a>
	<input class="title-editor" bind:value={cur_sheet.title} placeholder="Title">
	<input class="tag-editor" bind:value={cur_sheet.tags} placeholder="Tags: Add a tag so you can search or sort by tags later">
	<textarea rows="15" class="body-editor" bind:value={cur_sheet.body}></textarea>
</div>

<style>
	.editor-container {
		display: block;
	}

	.safe {
		background-color: #90fa39;
	}

	.danger {
		background-color: #fc8d8d;
	}

	.safe:hover {
		background: transparent;
	}
	
	.danger:hover{
		background: transparent;
	}

	.editor-container input, .editor-container textarea {
		display: block;
		margin-left: auto;
		margin-right: auto;
		width: 100%;
	}

	textarea {
		resize: vertical;
		width: 100%;
	}
</style>
